import { SdkBaseSectionModel } from './baseSection';

export class SdkFlowPageModel extends SdkBaseSectionModel {}
